module.exports = __webpack_public_path__ + "img/logo.ae759c46.png";